export const serviceFAQs = {
  assainissement: [
    {
      question: 'Quel est le coût d\'un système d\'assainissement complet ?',
      answer:
        'Le coût dépend de plusieurs facteurs : la taille de votre installation, le type de terrain, les normes de conformité requises et la localisation. Nous proposons une évaluation gratuite pour vous donner un devis précis adapté à vos besoins spécifiques.',
    },
    {
      question: 'Combien de temps prend l\'installation d\'un système d\'assainissement ?',
      answer:
        'La durée varie selon la complexité du projet. Un système standard prend généralement 2 à 4 semaines. Les projets plus importants peuvent prendre 6 à 8 semaines. Nous établissons un calendrier détaillé lors de la phase de planification.',
    },
    {
      question: 'Vos systèmes sont-ils conformes aux normes CEMAC ?',
      answer:
        'Oui, tous nos systèmes sont conçus et installés selon les normes environnementales en vigueur au Cameroun et dans la sous-région CEMAC. Nous respectons les directives du Ministère de l\'Environnement et de la Protection de la Nature.',
    },
    {
      question: 'Proposez-vous un service de maintenance après installation ?',
      answer:
        'Absolument. Nous offrons des contrats de maintenance régulière incluant l\'inspection, le nettoyage et les réparations nécessaires. Cela garantit le bon fonctionnement de votre système à long terme.',
    },
    {
      question: 'Peut-on installer un système de biogaz sur une installation existante ?',
      answer:
        'Oui, nous pouvons adapter ou améliorer les systèmes existants. Une évaluation technique est nécessaire pour déterminer la faisabilité et les modifications requises.',
    },
    {
      question: 'Quel est le délai avant que le biogaz devienne opérationnel ?',
      answer:
        'Après installation, le système de biogaz nécessite une période de démarrage de 2 à 4 semaines pour atteindre sa pleine capacité. Nous vous accompagnons tout au long de cette phase.',
    },
  ],
  hygiene: [
    {
      question: 'À quelle fréquence faut-il faire désinfecter ?',
      answer:
        'La fréquence dépend de votre secteur d\'activité. Pour les établissements de santé : hebdomadaire. Pour les restaurants : 2 à 3 fois par semaine. Pour les bureaux : mensuel. Nous recommandons une évaluation pour déterminer le calendrier optimal.',
    },
    {
      question: 'Vos produits de désinfection sont-ils écologiques ?',
      answer:
        'Nous utilisons des produits agréés par le Ministère de la Santé Publique, efficaces et conformes aux normes environnementales. Nous proposons également des options éco-responsables sur demande.',
    },
    {
      question: 'Êtes-vous agréés par le MINSANTE ?',
      answer:
        'Oui, nous sommes officiellement agréés par le Ministère de la Santé Publique du Cameroun. Notre agrément est valide et à jour, et nos interventions sont conformes aux directives officielles.',
    },
    {
      question: 'Pouvez-vous intervenir en urgence ?',
      answer:
        'Oui, nous offrons un service d\'urgence 24h/24. En cas de besoin immédiat, contactez-nous et nous dépêcherons une équipe dans les meilleurs délais.',
    },
    {
      question: 'Vos services incluent-ils la dératisation ?',
      answer:
        'Oui, nous proposons des services complets de dératisation et de contrôle des nuisibles. Cela inclut l\'inspection, le traitement et la prévention pour éviter les récidives.',
    },
    {
      question: 'Quel est le coût d\'un service de désinfection ?',
      answer:
        'Le coût dépend de la superficie à désinfecter et de la fréquence. Nous proposons des forfaits flexibles et des tarifs dégressifs pour les contrats annuels. Demandez un devis sans engagement.',
    },
  ],
  'controle-pollution': [
    {
      question: 'Quels types de pollution mesurez-vous ?',
      answer:
        'Nous mesurons la qualité de l\'air (CO, NOx, H2S), la qualité de l\'eau, les poussières, le bruit et les polluants spécifiques selon votre secteur d\'activité. Notre laboratoire est équipé des technologies les plus récentes.',
    },
    {
      question: 'Combien de temps pour obtenir les résultats d\'analyse ?',
      answer:
        'Les résultats préliminaires sont généralement disponibles sous 48 heures. Les analyses complètes avec rapports détaillés prennent 5 à 7 jours ouvrables.',
    },
    {
      question: 'Vos analyses sont-elles reconnues officiellement ?',
      answer:
        'Oui, notre laboratoire est agréé et nos analyses sont reconnues par les autorités environnementales camerounaises et CEMAC. Les rapports sont acceptés dans les procédures officielles.',
    },
    {
      question: 'Proposez-vous un suivi régulier de la pollution ?',
      answer:
        'Absolument. Nous proposons des plans de suivi personnalisés avec des mesures régulières (mensuelles, trimestrielles ou annuelles) pour surveiller l\'évolution de la pollution dans votre environnement.',
    },
    {
      question: 'Comment puis-je savoir si je suis conforme aux normes ?',
      answer:
        'Nous comparons vos mesures aux normes CEMAC et camerounaises applicables. Notre rapport inclut une évaluation de conformité avec des recommandations d\'amélioration si nécessaire.',
    },
    {
      question: 'Quel est le coût d\'une analyse complète ?',
      answer:
        'Les tarifs varient selon le type et le nombre d\'analyses. Nous proposons des forfaits adaptés aux petites, moyennes et grandes entreprises. Contactez-nous pour un devis détaillé.',
    },
  ],
  formation: [
    {
      question: 'Vos formations sont-elles certifiées ?',
      answer:
        'Oui, toutes nos formations sont certifiées. Les participants reçoivent une attestation de participation reconnue professionnellement à l\'issue de la formation.',
    },
    {
      question: 'Quelle est la durée typique d\'une formation ?',
      answer:
        'Nos formations varient de 1 à 5 jours selon le sujet. Le Management QHSE prend généralement 3 jours, la lutte incendie 2 jours, et le secourisme 2 à 3 jours.',
    },
    {
      question: 'Pouvez-vous adapter les formations à nos besoins spécifiques ?',
      answer:
        'Oui, nous proposons des formations sur mesure adaptées à votre secteur et vos risques spécifiques. Contactez-nous pour discuter de vos besoins en formation personnalisée.',
    },
    {
      question: 'Quel est le nombre maximum de participants par formation ?',
      answer:
        'Pour assurer une qualité pédagogique optimale, nous limitons les groupes à 15-20 participants par session. Cela permet une interaction efficace avec les formateurs.',
    },
    {
      question: 'Les formations incluent-elles du matériel pratique ?',
      answer:
        'Oui, nos formations sont très pratiques. Pour la lutte incendie et le secourisme, les participants utilisent du vrai matériel. Des études de cas réels sont utilisées pour le Management QHSE.',
    },
    {
      question: 'Proposez-vous des formations en ligne ?',
      answer:
        'Pour le moment, nous privilégions les formations en présentiel pour garantir la qualité. Cependant, nous explorons des options hybrides. Contactez-nous pour discuter de vos préférences.',
    },
  ],
  'support-qhse': [
    {
      question: 'Combien de temps faut-il pour obtenir une certification ISO 9001 ?',
      answer:
        'Le délai moyen est de 6 à 12 mois selon votre niveau de préparation initial. Cela inclut la phase de diagnostic, la mise en place du système, les audits internes et l\'audit de certification externe.',
    },
    {
      question: 'Quelles sont les étapes pour obtenir une certification ISO 14001 ?',
      answer:
        'Les étapes sont : 1) Audit diagnostic, 2) Conception du système, 3) Formation du personnel, 4) Mise en œuvre, 5) Audits internes, 6) Audit de certification par un organisme accrédité.',
    },
    {
      question: 'Pouvez-vous nous aider à maintenir nos certifications existantes ?',
      answer:
        'Oui, nous proposons un support continu incluant audits internes réguliers, formation du personnel, et assistance lors des audits de surveillance annuels.',
    },
    {
      question: 'Quel est le coût total d\'une certification ISO ?',
      answer:
        'Le coût varie selon votre taille et complexité, généralement entre 2 et 10 millions FCFA pour une PME. Cela inclut notre accompagnement et l\'audit de certification externe.',
    },
    {
      question: 'Pouvons-nous obtenir plusieurs certifications simultanément ?',
      answer:
        'Oui, nous recommandons une approche intégrée pour les certifications ISO 9001, 14001 et 45001. Cela réduit les coûts et crée un système de management cohérent.',
    },
    {
      question: 'Que se passe-t-il après la certification ?',
      answer:
        'Après certification, vous devez maintenir votre système avec des audits internes réguliers. Nous proposons un programme de support continu et des audits de surveillance annuels pour assurer la pérennité de votre certification.',
    },
  ],
};